import React, { useCallback , useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper } from '@mui/material';
import './ProductDetailsPage.scss';
import './BrandedMerchandise.scss';
import NoImage from '../PrivateBrandCatalog/assets/NoImage.png';
import AddToListButton from './AddToListButton';
import debounce from 'lodash.debounce';
import LoadingIndicator from '../Common/LoadingIndicator';
import { persistMyListForBM } from './BMService';

const ProductInfoTable = ({ productData }) => {
  const { isAdmin = false } = useSelector((state) => state.userManagement);
  const [persistingCart, setPersistingCart] = useState(false);
  const bmList = useSelector((state) => state.bmCollection.bmList);

  const debouncedPersistMyList = useCallback(
    debounce((list, timestampISOString) => {
      setPersistingCart(true);
      persistMyListForBM(
        list.map((listItem) => ({
          itemMasterId: listItem.id,
          count: listItem.count,
        })),
        timestampISOString
      )
        .then((res) => {
          setPersistingCart(false);
        })
        .catch((err) => {
          setPersistingCart(false);
        });
    }, 800),
    []
  );

  useEffect(() => {
    const timestampOfLocalChange = localStorage.getItem('bm_my_list_timestamp') || new Date().toISOString();
    const localDate = new Date(timestampOfLocalChange);
    const timestampOfRemoteChange = new Date(localDate.getTime() + 1000).toISOString();
    debouncedPersistMyList(bmList, timestampOfRemoteChange);
  }, [bmList, debouncedPersistMyList]);

  if (!productData) return null;
  const [ imageUrl = NoImage ] = productData?.imageUrl || [];
  
  return (
    <div className="product-info-container">
      <div className="product-image">
      <img src={imageUrl}/>
      </div>
      {persistingCart && <LoadingIndicator enableBackdrop={true}/>}
      <div className="product-details">
        <TableContainer component={Paper} className="product-details-table">
          <Table>
            <TableBody>
              {[
                { label: 'Style', value: productData.brandedMerchandiseStyle },
                { label: 'Product Name', value: productData.shortDescription },
                { label: 'Sizing', value: productData.brandedMerchandiseSize },
                { label: 'Port', value: productData.brandedMerchandisePort },
                { label: 'Description', value: productData.longDescription },
                { label: 'Pricing USD ', value: `$${productData.brandedMerchandisePrice.toFixed(2)}` },
                { label: 'SRP USD ', value: `$${productData.minSrp.toFixed(2)}` },
                { label: 'Minimum Order Quantity ', value: productData.minimumOrderQty },
                ...(isAdmin ? [{ label: 'Supplier', value: productData.brandedMerchandiseSupplier }] : []),
                // { label: 'Collection', value: productData.itemHierarchies[0]?.itemHierarchyCode?.description }
              ].map((item, index) => (
                <TableRow key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                  <TableCell className="attribute-cell">{item.label}</TableCell>
                  <TableCell className="value-cell"><pre>{item.value}</pre></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <AddToListButton itemId={productData.itemMasterID} />
      </div>
    </div>
  );
};

export default ProductInfoTable;
